// Generated by Melange

import * as Buhta_core__GlobalStateContext from "../../../../packages/core/lib/GlobalStateContext.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../vendored/classnames/Cn.js";
import * as JsxRuntime from "react/jsx-runtime";

function DashboardTemplate(Props) {
  let sidebarOpt = Props.sidebar;
  let children = Props.children;
  const sidebar = sidebarOpt !== undefined ? Caml_option.valFromOption(sidebarOpt) : null;
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  return JsxRuntime.jsxs("div", {
    children: [
      sidebar,
      children
    ],
    className: Cn.$plus("flex w-full h-screen", Cn.on("flex-col", deviceType === "mobile"))
  });
}

const make = DashboardTemplate;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
